import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormControl } from '../../../../../facturotopia';
import ComercioExteriorMercanciasUploadFile from './ComercioExteriorMercanciasUploadFile';
import ComercioExteriorCatalogoManager from '../../../../catalogs/managers/ComercioExteriorCatalogoManager';
import ComercioExteriorMercanciasCalculator from '../../../support/comercio-exterior/ComercioExteriorMercanciasCalculator';
import ComercioExteriorFraccionArancelariaSuggestions from '../../../../catalogs/ComercioExteriorFraccionArancelariaSuggestions';
import ComercioExteriorMercanciaDescripcionesEspecificasManager from './ComercioExteriorMercanciaDescripcionesEspecificasManager';

class ComercioExteriorMercanciaForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      show: false,
      isValid: false,
      limiteInferior: 0,
      limiteSuperior: 0,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidMount() {
    const UnidadAduana = ComercioExteriorCatalogoManager.get('c_ce_unidad_aduana');

    let catalogos = {};

    catalogos.UnidadAduana = this.getCatalogo(UnidadAduana, 'descripcion', 'unidad_medida');

    this.setState({
      catalogos
    });
  }

  getCatalogo = (values, label, value) => {
    if (!!values) {
      const sorted = _.sortBy(values.map((item) => {
        return {
          label: `${item[label]} (${item[value]})`,
          value: item[value]
        }
      }), 'label');

      return [
        {
          label: 'Selecciona',
          value: ''
        }
      ].concat(sorted);
    }
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true,
        descripciones_especificas: !!data.DescripcionesEspecificas,
      });
    }
  }

  rules(data) {
    return {
      'NoIdentificacion': ['required', 'string', 'min:1', 'max:100'],
      'FraccionArancelaria': ['required', 'string'],
      'CantidadAduana': ['min:0.001', 'regex:/^[0-9]{1,14}(.([0-9]{1,3}))?$/'],
      'UnidadAduana': ['string'],
      'ValorUnitarioAduana': ['string', 'regex:/^[0-9]{1,16}(.([0-9]{1,2}))?$/'],
      'ValorDolares': ['required', 'string', 'regex:/^[0-9]{1,16}(.([0-9]{1,2}))?$/']
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    const limiteInferior = ComercioExteriorMercanciasCalculator.make(data).getLimiteInferior();
    const limiteSUperior = ComercioExteriorMercanciasCalculator.make(data).getLimiteSuperior();

    this.setState({
      data,
      isValid: validator.passes(),
      limiteInferior: limiteInferior,
      limiteSuperior: limiteSUperior
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.handleOnSuggestionSelect(undefined);

    this.setState({
      data: {},
      limiteInferior: 0,
      limiteSuperior: 0,
      isValid: false,
      descripciones_especificas: false,
    })
  }

  handleOnAdditionalCheckboxChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      [name]: checked
    });
  }

  handleOnAdditionalChange = (additional) => {
    this.setState({
      data: {
        ...this.state.data,
        ...additional
      }
    });
  }

  handleOnSuggestionSelect = (name) => (item) => {
    const value = item ? item.fraccion_arancelaria : '';

    let values = {
      [name]: value
    };

    this.handleOnChange(values);
  }

  handleOnDetalleMercanciaDataChange = (event) => {
    const data = {
      ...this.state.data.DetalleMercancia,
      ...event.data,
    }

    this.setState({
      data: {
        ...this.state.data,
        DetalleMercancia: data,
      },
    });
  }

  handleOnShow = () => {
    this.setState({
      show: true
    });
  }

  handleOnClose = (values) => {
    this.setState({
      ...this.state.data,
      ...values
    });
  }

  handleOnAddFile = (values) => {
    this.props.onAddFile(values);
  }

  render() {
    const rules = this.rules();
    const {
      isValid,
      descripciones_especificas,
      data = {},
      catalogos = {},
      limiteInferior,
      limiteSuperior,
      show
    } = this.state;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número Identificación"
              name="NoIdentificacion"
              placeholder=""
              help=""
              minLength="1"
              maxLength="100"
              rules={ rules.NoIdentificacion }
              value={ data.NoIdentificacion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <ComercioExteriorFraccionArancelariaSuggestions
              label="Fracción Arancelaria"
              name="FraccionArancelaria"
              rules={ rules.FraccionArancelaria }
              value={ data.FraccionArancelaria }
              onSelect={ this.handleOnSuggestionSelect('FraccionArancelaria') }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Cantidad Aduana"
              name="CantidadAduana"
              placeholder=""
              help=""
              rules={ rules.CantidadAduana }
              value={ data.CantidadAduana }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Unidad Aduana"
              name="UnidadAduana"
              placeholder=""
              help=""
              rules={ rules.UnidadAduana }
              value={ data.UnidadAduana }
              options={ catalogos.UnidadAduana }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Valor Unitario Aduana"
              name="ValorUnitarioAduana"
              placeholder=""
              help=""
              rules={ rules.ValorUnitarioAduana }
              value={ data.ValorUnitarioAduana }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Valor en Dolares"
              name="ValorDolares"
              placeholder=""
              rules={ rules.ValorDolares }
              value={ data.ValorDolares }
              onChange={ this.handleOnChange }
            />
          </Col>

        </Row>

        <Row>
          <Col>
            <p className="text-muted">
              El Valor en Dolares debe ser mayor o igual que el límite inferior y menor o igual que el límite superior.
            </p>
          </Col>
        </Row>

        <Row>
          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Límite Inferior"
              name="LimiteInferior"
              placeholder=""
              help=""
              readOnly
              value={ limiteInferior }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Límite Superior"
              name="LimiteSuperior"
              placeholder=""
              help=""
              readOnly
              value={ limiteSuperior }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="descripciones_especificas">
              <Form.Check type="checkbox"
                name="descripciones_especificas"
                label="Incluir Descripciones Específicas"
                checked={ descripciones_especificas || false }
                onChange={ this.handleOnAdditionalCheckboxChange }
              />
            </Form.Group>
          </Col>
        </Row>

        { !!descripciones_especificas && (
          <ComercioExteriorMercanciaDescripcionesEspecificasManager
            data={ data }
            onChange={ this.handleOnAdditionalChange }
          />
        )}

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varias Mercancias usando el botón "Agregar Mercancia", la lista se mostrarán en la tabla de Mercancias.
            </p>
          </Col>
        </Row>

        <Row className="pt-3">
          { Guardian.allows('excel_comercioexterior.access') && (
            <Col>
              <Button variant="secondary"
                onClick={ this.handleOnShow }
              >
                <FontAwesomeIcon icon={ ['fas', 'upload'] } /> Usar excel
              </Button>
            </Col>
          )}

          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar Mercancia
            </Button>
          </Col>
        </Row>

        { !!show && (
          <ComercioExteriorMercanciasUploadFile
            data={ data }
            show={ show }
            onAdd={ this.handleOnAddFile }
            onClose={ this.handleOnClose }
          />
        )}
      </>
    )
  }
}

export default ComercioExteriorMercanciaForm;